import {
  BenzingaLogo,
  BenzingaEsLogo,
  BenzingaFrLogo,
  BenzingaItLogo,
  BenzingaCryptoLogo,
  BenzingaIndiaLogo,
  BenzingaKoreaLogo,
  BenzingaJapanLogo,
  LogoVariant,
} from '@benzinga/logos-ui';
import styled from '@benzinga/themetron';
import { appEnvironment, appName } from '@benzinga/utils';
import React from 'react';

export interface NavigationLogoProps {
  logoVariant?: LogoVariant;
  deviceType?: 'mobile' | 'desktop';
}

const LogosVariants = {
  france: {
    desktop: {
      Component: BenzingaFrLogo,
      props: {},
    },
    mobile: {
      Component: BenzingaFrLogo,
      props: {
        variant: 'light',
      },
    },
  },
  india: {
    desktop: {
      Component: BenzingaIndiaLogo,
      label: 'Click to go to India home',
      props: {
        variant: 'dark',
      },
    },
    mobile: {
      Component: BenzingaIndiaLogo,
      label: 'Click to go to India home',
      props: {
        variant: 'light',
      },
    },
  },
  italy: {
    desktop: {
      Component: BenzingaItLogo,
      props: {},
    },
    mobile: {
      Component: BenzingaItLogo,
      props: {
        variant: 'light',
      },
    },
  },
  japan: {
    desktop: {
      Component: BenzingaJapanLogo,
      props: {},
    },
  },
  korea: {
    desktop: {
      Component: BenzingaKoreaLogo,
      props: {},
    },
  },
  spain: {
    desktop: {
      Component: BenzingaEsLogo,
      props: {},
    },
    mobile: {
      Component: BenzingaEsLogo,
      props: {
        variant: 'light',
      },
    },
  },
};

export const NavigationLogo: React.FC<NavigationLogoProps> = ({ deviceType = 'desktop', logoVariant = '' }) => {
  const isMoneyApp = appEnvironment().isApp(appName.money);

  const LogoVariantData = React.useMemo(
    () => LogosVariants[logoVariant]?.[deviceType] ?? LogosVariants[logoVariant]?.['desktop'] ?? null,
    [logoVariant, deviceType],
  );

  if (deviceType === 'mobile') {
    return (
      <LogoWrapper className="logo-wrapper mobile-logo-wrapper">
        {LogoVariantData ? (
          <a aria-label={LogoVariantData.label ?? 'Click to go home'} href="/">
            <LogoVariantData.Component {...LogoVariantData.props} />
          </a>
        ) : (
          <a aria-label="Click to go home" href="/">
            <BenzingaLogo deviceType={deviceType} variant="light" />
          </a>
        )}
      </LogoWrapper>
    );
  }
  return (
    <LogoWrapper className="logo-wrapper mobile-logo-wrapper">
      {logoVariant === 'crypto' && appEnvironment().isApp(appName.bz) ? (
        <a aria-label="Click to go to the Crypto home page" className="benzinga-crypto-logo-wrapper" href="/crypto">
          <BenzingaCryptoLogo />
        </a>
      ) : (
        <>
          {LogoVariantData ? (
            <a aria-label={LogoVariantData.label ?? 'Click to go home'} href="/">
              <LogoVariantData.Component {...LogoVariantData.props} />
            </a>
          ) : (
            <a aria-label="Click to go home" href="/">
              <BenzingaLogo deviceType={deviceType} variant={isMoneyApp ? 'light' : 'dark'} />
            </a>
          )}
          {isMoneyApp && (
            <a aria-label="Click to go to Benzinga Money" href="/money">
              <SiteLabel>
                <span>{appEnvironment().app()}</span>
              </SiteLabel>
            </a>
          )}
        </>
      )}
    </LogoWrapper>
  );
};

export const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 0 ${({ theme }) => theme.space[1]};
  padding-right: ${({ theme }) => theme.space[0]};
  width: ${({ theme }) => (appEnvironment().isApp(appName.india) ? theme.space['72'] : theme.space['48'])};
  min-width: 144px;

  .benzinga-crypto-logo-wrapper {
    margin-bottom: -1px;
  }

  > a {
    display: inline-flex;
  }
`;

const SiteLabel = styled.div`
  color: #3effdc;
  margin-left: 8px;
  display: flex;
  align-items: center;
  span {
    border-left: 2px solid #395173;
    padding-left: 8px;
    display: inline-block;
    line-height: 1;
    font-weight: 600;
    text-transform: capitalize;
  }
`;
